import createActionType from "../utils/createActionType";

export const MODULE = "sales-orders/split-order";

export const SET_IS_FETCHING_STATUS = createActionType(MODULE, "setIsFetchingStatus");

export const SET_PRODUCTS = createActionType(MODULE, "setProducts");

export const SET_NEW_PRODUCT_DATA = createActionType(MODULE, "setNewProductData");

export const SET_IS_SAVING_STATUS = createActionType(MODULE, "setIsSavingStatus");

export const SET_IS_CONFIRMATION_MODAL_VISIBLE = createActionType(
  MODULE,
  "setIsConfirmationModalVisible"
);

export const RESET = createActionType(MODULE, "reset");
